import { SEEducationDetails, SERecognitionApplication } from "../types/seRecognitionTypes";
import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialSEVerLetterApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import SEVerLetterStepApplicant from "../views/components/services/secondaryEducation/form/applicant/SEVerLetterStepApplicant";
import SeVerLetterStepEducation from "../views/components/services/secondaryEducation/form/education/SeVerLetterStepEducation";
import SEVerLetterStepDocuments from "../views/components/services/secondaryEducation/form/documents/SEVerLetterStepDocuments";
import SEVerLetterStepFiling from "../views/components/services/secondaryEducation/form/filing/SEVerLetterStepFiling";
import React from "react";
import { initialSeRecognitionEducation } from "./seRecognitionInitialValues";

export const initialSeVerLetterEducation: SEEducationDetails = {
  ...initialSeRecognitionEducation,
  hasCertificate: false,
  hasVerificationLetter: true,
};

export const initialSeVerLetterApplication: SERecognitionApplication = {
  educationDetails: initialSeVerLetterEducation,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialSEVerLetterApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <SEVerLetterStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.education",
      completed: false,
      component: <SeVerLetterStepEducation />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <SEVerLetterStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <SEVerLetterStepFiling />,
      isEdited: false,
    },
  ],
};
